import { configureStore } from "@reduxjs/toolkit";
import { PackageTypeApi } from "../API/PackageTypeApi";
import { PackageApi } from "../API/PackageApi";
import { BlogApi } from "../API/BlogApi";
import { BannerApi } from "../API/BannerApi";
import { LoginApi } from "../API/LoginApi";
import { ContactApi } from "../API/ContactApi";
import { reducer } from "../reducer/reducer";
import { DestinationApi } from "../API/DestinationApi";
import { ThemeApi } from "../API/ThemeApi";
import { ReferencePackageApi } from "../API/ReferenceApi";
// import { BannerApi } from "../API/BannerApi";

export const store = configureStore({
  reducer: {
    reducer: reducer.reducer,
    [PackageTypeApi.reducerPath]: PackageTypeApi.reducer,
    [PackageApi.reducerPath]: PackageApi.reducer,
    [BlogApi.reducerPath]: BlogApi.reducer,
    [BannerApi.reducerPath]: BannerApi.reducer,
    [LoginApi.reducerPath]: LoginApi.reducer,
    [ContactApi.reducerPath]: ContactApi.reducer,
    [DestinationApi.reducerPath]: DestinationApi.reducer,
    [ThemeApi.reducerPath]: ThemeApi.reducer,
    [ReferencePackageApi.reducerPath]:ReferencePackageApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      [PackageTypeApi.middleware],
      [PackageApi.middleware],
      [BlogApi.middleware],
      [BannerApi.middleware],
      [LoginApi.middleware],  
      [ContactApi.middleware],
      [DestinationApi.middleware],
      [ThemeApi.middleware],
      [ReferencePackageApi.middleware],
    ),
});
